import { useState, useEffect } from 'react';

const LOCALIZATION_QUERY = `
  query getLocalization {
    localization {
      availableCountries {
        isoCode
        name
        currency {
          isoCode
          name
          symbol
        }
      }
    }
  }
`;

export const useShopifyCountries = () => {
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCountries = async () => {
            // Check if we're in the browser
            if (typeof window === 'undefined') {
                setLoading(false);
                return;
            }

            try {
                const response = await fetch(
                    `https://lineage-journey.myshopify.com/api/2024-01/graphql.json`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': 'e3e6f7f2ffec6ef5ba855eaaeb608d83',
                        },
                        body: JSON.stringify({ query: LOCALIZATION_QUERY }),
                    }
                );

                const result = await response.json();

                if (result.errors) {
                    throw new Error(result.errors[0].message);
                }

                if (result.data?.localization?.availableCountries) {
                    setCountries(result.data.localization.availableCountries);
                }
            } catch (err) {
                console.error('Error fetching Shopify countries:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCountries();
    }, []);

    return { countries, loading, error };
};

export const useShopifyCurrencies = () => {
    const { countries, loading, error } = useShopifyCountries();
    const [currencies, setCurrencies] = useState([]);

    useEffect(() => {
        if (countries.length > 0) {
            // Get unique currencies
            const currenciesMap = new Map();

            countries.forEach(country => {
                if (!currenciesMap.has(country.currency.isoCode)) {
                    currenciesMap.set(country.currency.isoCode, {
                        isoCode: country.currency.isoCode,
                        name: country.currency.name,
                        symbol: country.currency.symbol,
                        countries: [],
                    });
                }
                currenciesMap.get(country.currency.isoCode).countries.push({
                    isoCode: country.isoCode,
                    name: country.name,
                });
            });

            setCurrencies(Array.from(currenciesMap.values()));
        }
    }, [countries]);

    return { currencies, loading, error };
};